import {
	parse,
	eval as expEval,
	addBinaryOp,
	addUnaryOp,
} from "expression-eval";

// Add custom operators
//@ts-ignore
addBinaryOp("**", 11, Math.pow);

//@ts-ignore
addUnaryOp("sqrt", Math.sqrt);

//@ts-ignore
addUnaryOp("asin", Math.asin);

export const evaluateExpression = (exp, data) => {
	const ast = parse(exp);

	return expEval(ast, data);
};
